module.exports = __webpack_public_path__ + "static/img/iwatch_Nike4.d5f4e1e5.jpg";